export default {
  getYears () {
    this.$http.get('/v1/dweller/file/years')
    .then(({data}) => {
      this.years = data
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/files/resources/methods.js